import { API_CONFIG } from '@/constants/config';
import apiClient from '@/services/apiClient';

async function getEncryptedSSOData(timeout = 30000) {
    if (process.env.NODE_ENV === 'development') {
        const ahmadDecryptedSso =
            'U2FsdGVkX1/CSSBArtYGeN/KT7wadqLyyfxWuKyNFYhR6EQI15gyG7v8hai56iKpGWMdCfzw32KxKdXGvZs28S//5R5EHldtiaC9dS//WdxXIE+MNdigwMlpP/2ZowEXKVGyKY1tAhFc23UXlw/ozu1l2tTxVVl1mTsqyiRkzIesQycDOJiMkjKbKd2TXniTsqtyCHd+IzHP1K+T/YIdYHBXCJPZQhqq3kvWZQVLRiWXlOCQdTjvRfJz8CA/E99cSMaNmxKrR5c065c+cvFbVUkMXqeS8WGhDg9/6MIemkLBe/2o5I0qjj0zvqvyuYWrm3x2kUAADPgnUnbvCSu6Y43Dcn3Y+F1R6kQ3X6ZL0ZKUoYaeLMIVhDyCsz7vHmFJn9tAjaCtKQPE1u1tNV+GH53ZSQuSWpi22+39CSZ9PRBqX+m11ZqMvEzK45qebT2k0i7eqPa7t4wniVZWbboXAb88CraUaH9WvCwGPWaNCGVOOzur1arq6jVmGtffyQQ21FGQ1FT6V1KRJ3jI1Vyqf3Ct0kvbBBQOFNDagWT3KXDONYgRiMhKWCX7rnOV54vNekq9nbzRfkWHv5fLs+v6yL5yBDKtqPmrcRb7oL9XByp1pRzJyQfiDFH91/ioLb2KxFJ4y2uUMmeUUPHW8YiyQPimxQA5RPt54E3y3xd8rYI=';

        const kumailDecryptedSso =
            'U2FsdGVkX1/SuRa6X19cFMpsIEwB97ddt6sL18ZTdvx2dvBabVQPtt6b14XypjAdkIgzc9eCK3IZM9CsTkRVhQPNNPzTQ7Fzo6G9v+SqyiibIO4XLbQh0Qa0eGNN/5maWlfY21A/eGfNNdZuAOhDdGm8eA/XF51wpGVa0su0IDDlxD2bGipjMb8FqjPLYQSzlS05zwE1TDTbG1MEQ2BV5pqlV35d07q84A8+Af0Hayu2NDqirlL/XhJzIqEzuINJBBWHsj3BaI66ICEVo96BrCPmwwQuleYIijnopAHKVB8j4Z6P443CtkFYGPbckXHdGLHwBehASyizWjrBcfDubTUtiRUBjkJmCIe1sEQDwJ2oeb0e47IPjixV2+CkcEAWES3fJ8lf99eEJgdtmV0oZlRCVbiMboeNPqdYTxGx0C1pvHKypo/zpqSLyZ8CvqPd4TKj/XbYlb3LLNelW/1IP6SFcUS1dpL9H6tc56lTfz3wRd+UcRved6sz4eK03H26LGQ1w6UOcaoLnglcCunNwWHfEDZA1mxxxSQzN7xtRCgZFNkDiHZlsxnkA/z7mhKHbnOErYC8VL2eR0e4H+4M+CeURIR2s+cz82C/URWHUXWRB0PVZ9UCDkr3e75jKTK6Gb3YsYzmUuRE+N1peeS/yIhml/LjFa4UHkvs0SrKMYg=';

        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(ahmadDecryptedSso);
            }, 1000);
        });
    }

    return new Promise((resolve, reject) => {
        const handler = ({ data }) => {
            if (data?.message === 'REQUEST_USER_DATA_RESPONSE') {
                window.removeEventListener('message', handler);
                resolve(data.payload);
            }
        };

        window.addEventListener('message', handler);
        window.parent.postMessage({ message: 'REQUEST_USER_DATA' }, '*');
        setTimeout(() => {
            window.removeEventListener('message', handler);
            reject(new Error('Timeout waiting for user data response'));
        }, timeout);
    });
}

async function fetchUserData(requestBody) {
    return apiClient(API_CONFIG.ENDPOINTS.GET_USER_DATA, {
        method: 'POST',
        body: JSON.stringify(requestBody),
    });
}

async function fetchSmsNumbers(storeState, encCodeURI, forceFetch = false) {
    if (
        !forceFetch &&
        (storeState.sms?.bnum_list?.length !== 0 ||
            storeState.sms === 'Not Available')
    ) {
        return {
            status: storeState.sms === 'Not Available' ? 204 : 200,
            data: {
                bnum_list: storeState.sms?.bnum_list || [],
                has_selected_bnum: storeState.sms?.has_selected_bnum || '',
                selected_bnum: storeState.sms?.selected_bnum || '',
                fallback_number_details: storeState.sms
                    ?.fallback_number_details || {
                    fallback_bnum: '',
                    user_id: '',
                },
            },
            error: '',
        };
    }

    return apiClient(
        `${API_CONFIG.ENDPOINTS.SMS_BNUMS}?encryptedSSOData=${encCodeURI}`
    );
}

async function setSmsDefault(config) {
    return apiClient(API_CONFIG.ENDPOINTS.SMS_BNUMS, {
        method: 'POST',
        body: JSON.stringify(config),
    });
}

async function setFallbackBnum(config) {
    return apiClient(API_CONFIG.ENDPOINTS.SMS_BNUMS, {
        method: 'POST',
        body: JSON.stringify(config),
    });
}

async function fetchWebcallNumbers(storeState, encCodeURI, forceFetch = false) {
    if (
        !forceFetch &&
        (storeState.webcall?.bnum_list?.length !== 0 ||
            storeState.webcall === 'Not Available')
    ) {
        return {
            status: storeState.webcall === 'Not Available' ? 204 : 200,
            data: {
                bnum_list: storeState.webcall?.bnum_list || [],
                has_selected_bnum: storeState.webcall?.has_selected_bnum || '',
                selected_bnum: storeState.webcall?.selected_bnum || '',
            },
            error: '',
        };
    }

    return apiClient(
        `${API_CONFIG.ENDPOINTS.WEBCALL_BNUMS}?encryptedSSOData=${encCodeURI}`
    );
}

async function setWebcallDefault(config) {
    return apiClient(API_CONFIG.ENDPOINTS.WEBCALL_BNUMS, {
        method: 'POST',
        body: JSON.stringify(config),
    });
}

async function fetchAvailableUsers(storeState, encCodeURI, forceFetch = false) {
    if (!forceFetch && storeState.length !== 0) {
        const clonedUsers = storeState.map((user) => ({ ...user }));

        return {
            status: 200,
            data: {
                users: clonedUsers,
                message: 'GHL users successfully retrieved from Redux',
                success: true,
            },
            error: '',
        };
    }
    return apiClient(
        `${API_CONFIG.ENDPOINTS.MANAGE_GHL_USERS}?encryptedSSOData=${encCodeURI}`
    );
}

async function createNewUserConfiguration(config) {
    return apiClient(API_CONFIG.ENDPOINTS.MANAGE_GHL_USERS, {
        method: 'POST',
        body: JSON.stringify(config),
    });
}

async function deleteUserConfiguration(config) {
    const { encryptedSSOData, deletedUserId } = config;

    return apiClient(
        `${API_CONFIG.ENDPOINTS.MANAGE_GHL_USERS}?encryptedSSOData=${encryptedSSOData}&deletedUserId=${deletedUserId}`,
        {
            method: 'DELETE',
        }
    );
}

export {
    getEncryptedSSOData,
    fetchUserData,
    fetchSmsNumbers,
    fetchWebcallNumbers,
    setSmsDefault,
    setFallbackBnum,
    setWebcallDefault,
    fetchAvailableUsers,
    createNewUserConfiguration,
    deleteUserConfiguration,
};
